// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddMaterialItemModalMetadataQueryVariables = Types.Exact<{
  filter: Types.LocationsFilter;
}>;


export type AddMaterialItemModalMetadataQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, path?: string | null | undefined, name: string, displayLocationPath: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string } }> };


export const AddMaterialItemModalMetadataDocument = gql`
    query AddMaterialItemModalMetadata($filter: LocationsFilter!) {
  locations(filter: $filter, effectiveLocations: true) {
    id
    path
    name
    displayLocationPath
    type {
      code
      name
    }
  }
}
    `;

/**
 * __useAddMaterialItemModalMetadataQuery__
 *
 * To run a query within a React component, call `useAddMaterialItemModalMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddMaterialItemModalMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddMaterialItemModalMetadataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAddMaterialItemModalMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddMaterialItemModalMetadataQuery, AddMaterialItemModalMetadataQueryVariables> & ({ variables: AddMaterialItemModalMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddMaterialItemModalMetadataQuery, AddMaterialItemModalMetadataQueryVariables>(AddMaterialItemModalMetadataDocument, options);
      }
export function useAddMaterialItemModalMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddMaterialItemModalMetadataQuery, AddMaterialItemModalMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddMaterialItemModalMetadataQuery, AddMaterialItemModalMetadataQueryVariables>(AddMaterialItemModalMetadataDocument, options);
        }
// @ts-ignore
export function useAddMaterialItemModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddMaterialItemModalMetadataQuery, AddMaterialItemModalMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddMaterialItemModalMetadataQuery, AddMaterialItemModalMetadataQueryVariables>;
export function useAddMaterialItemModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddMaterialItemModalMetadataQuery, AddMaterialItemModalMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddMaterialItemModalMetadataQuery | undefined, AddMaterialItemModalMetadataQueryVariables>;
export function useAddMaterialItemModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddMaterialItemModalMetadataQuery, AddMaterialItemModalMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddMaterialItemModalMetadataQuery, AddMaterialItemModalMetadataQueryVariables>(AddMaterialItemModalMetadataDocument, options);
        }
export type AddMaterialItemModalMetadataQueryHookResult = ReturnType<typeof useAddMaterialItemModalMetadataQuery>;
export type AddMaterialItemModalMetadataLazyQueryHookResult = ReturnType<typeof useAddMaterialItemModalMetadataLazyQuery>;
export type AddMaterialItemModalMetadataSuspenseQueryHookResult = ReturnType<typeof useAddMaterialItemModalMetadataSuspenseQuery>;
export type AddMaterialItemModalMetadataQueryResult = Apollo.QueryResult<AddMaterialItemModalMetadataQuery, AddMaterialItemModalMetadataQueryVariables>;